module.exports = __webpack_public_path__ + "img/1.e831aab4.png";